module.exports = __webpack_public_path__ + "img/crewFamilyXmasParty1.9978dd32.jpg";